<template>
  <span>
      <span v-if="this.status === 'PAYING' || this.status === 'CUSTOMER_PAYING'" 
        class="base-payment-status paying-status"
      >
        <img src="@/assets/payment-status-icons/minus-circle.png"  />
      </span>
      <span v-else-if="this.status === 'UNPAID' || this.status === 'CUSTOMER_UNPAID'" class="base-payment-status unpaid-status">
        <img src="@/assets/payment-status-icons/circle.png"  />
      </span>
      <span v-else-if="this.status === 'PAID_IN_FULL'" class="base-payment-status paid-in-full-status">
        <img src="@/assets/payment-status-icons/check-circle.png"  />
      </span>
      <span v-else></span>
  </span>
</template>

<script>
export default {
    props: {
        status: String,
    }
}
</script>

<style>

</style>